import { Component } from '@angular/core';

@Component({
  selector: 'app-barchart',
  template: '<app-chart-output></app-chart-output>'
})
export class BarChartComponentCustom {
 
}
